import { Pipe, PipeTransform } from '@angular/core';

// Moment
import * as moment from 'moment';

@Pipe({
  name: 'statementDateFormat'
})
export class StatementDateFormatPipe implements PipeTransform {

  // Transform
  public transform(value: any, args?: string): any {
    const language: string = args ? args.split('-')[0] : 'en';
    // Parse date because of IE date format restrictions
    const date = value.split(' ')[0].split('-');
    const hours = value.split(' ')[1].split(':');
    const time = new Date(date[0], Number(date[1]) - 1, date[2], hours[0], hours[1], hours[2]);

    return moment(time.getTime()).utc(true).locale(language).format('MMMM Do YYYY, h:mm a');
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/statements-date-format/statement-date-format.pipe.ts